import { useOutletContext } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { ShieldX, AlertTriangle } from 'lucide-react';

/**
 * FeatureGuard - Wraps pages that can be disabled by admin
 * Shows a warning message if the feature is disabled for the current team
 */
export default function FeatureGuard({ featureKey, children, pageName }) {
  const context = useOutletContext();
  const { teamFeatures, featuresLoading } = context || {};

  // While loading, show loading spinner
  if (featuresLoading) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  // Check if feature is enabled
  const isEnabled = teamFeatures ? teamFeatures[featureKey] !== false : true;

  // If feature is disabled, show warning
  if (!isEnabled) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <Card className="max-w-md w-full shadow-xl border-0 overflow-hidden">
          <CardContent className="pt-12 pb-12 text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-red-100 to-orange-100 flex items-center justify-center">
              <ShieldX className="w-10 h-10 text-red-500" />
            </div>
            <h2 className="text-2xl font-bold mb-3 text-gray-800">
              Bu Sayfa Aktif Değil
            </h2>
            <p className="text-gray-600 mb-4">
              <strong>{pageName || 'Bu uygulama'}</strong> mağazanız için devre dışı bırakılmış.
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 text-left">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-yellow-800">
                  <p className="font-medium mb-1">Ne yapabilirsiniz?</p>
                  <p>Bu özelliği aktif hale getirmek için mağaza yöneticinizle veya sistem admini ile iletişime geçin.</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Feature is enabled, render children
  return children;
}
